export default __webpack_public_path__ + "static/media/detail.93fab2be.png";